import * as React from "react"
import Svg, { G, Path, Rect } from "react-native-svg"
/* SVGR has dropped some elements not supported by react-native-svg: title */

function Search(props) {
  const { size } = props;
   
  return (
    <Svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" {...props}>
      <G fill="none" fillRule="evenodd">
        <Rect
          x={0.5}
          y={0.5}
          width={326}
          height={47}
          rx={4}
          transform="translate(-14 -12)"
          fill="#FEFEFE"
          stroke="#7EBC56"
        />
        <Path
          d="M10.15 0C4.561 0 0 4.561 0 10.15S4.561 20.3 10.15 20.3c2.535 0 4.85-.945 6.633-2.492l.617.617V20.3l8.7 8.7 2.9-2.9-8.7-8.7h-1.875l-.617-.617A10.09 10.09 0 0 0 20.3 10.15C20.3 4.561 15.739 0 10.15 0ZM10 2.806c3.883 0 7 3.125 7 7.017a6.987 6.987 0 0 1-7 7.016c-3.883 0-7-3.125-7-7.016a6.987 6.987 0 0 1 7-7.017Z"
          fill="#195820"
          fillRule="nonzero"
        />
      </G>
    </Svg>
  )
}

export default Search
